<div class="call-flow-container">
  <div class="call-flow-container__side-nav">
    <ziro-auto-attendant-call-flows-side-nav
      [standardCallFlows]="standardCallFlows()"
      [holidayCallFlows]="localHolidayCallFlows()"
      [flowsWithErrors]="flowsWithErrors()"
      [selectedFlowId]="selectedCallFlow()?.id ?? null"
      (callFlowSelected)="onCallFlowSelected($event)"
      (duplicateHolidayCallFlow)="onDuplicateHolidayCallFlow($event)"
      (deleteHolidayCallFlow)="onDeleteHolidayCallFlow($event)"
      (addHolidayCallFlow)="onAddHolidayCallFlow()"
    ></ziro-auto-attendant-call-flows-side-nav>

    <ziro-collapsible-section-card
      data-automation="referenced-by-section"
      [isSwitchHidden]="true"
      [isCollapsible]="false"
      [title]="'tkey;admin.teams_voice_management.teams_auto_attendant.references'"
      [hasLoadingState]="true"
      [isLoadingInput]="isLoadingReferences()"
    >
      @if (!references().length) {
        <div class="text-muted small" data-automation="references-none">
          {{ 'tkey;admin.teams_voice_management.teams_auto_attendant.references.none' | translate }}
        </div>
      } @else {
        @for (ref of references(); track ref.id; let i = $index) {
          <div
            class="d-flex align-items-center justify-content-between py-2"
            [class.border-bottom]="i < references().length - 1"
            [attr.data-automation]="'reference-row-' + ref.id"
            [attr.data-href]="getReferenceHref(ref)"
          >
            <div class="d-flex align-items-center gap-2 min-w-0">
              <i class="fa {{ getReferenceIcon(ref.type) }}" [attr.data-automation]="'reference-icon-' + ref.id"></i>
              <div class="min-w-0">
                <div
                  class="text-truncate small fw-semibold"
                  [attr.data-automation]="'reference-display-name-' + ref.id"
                >
                  {{ ref.displayName }}
                </div>
                <div
                  class="text-muted call-flow-container__side-nav__references__label"
                  [attr.data-automation]="'reference-type-label-' + ref.id"
                >
                  {{ getReferenceTypeLabel(ref.type) }}
                </div>
              </div>
            </div>
            <ziro-button
              [cssClass]="'ms-2 flex-shrink-0 btn-border'"
              [dataAutomation]="'reference-navigate-button-' + ref.id"
              [icon]="ZiroIcons.NEXT"
              [buttonStyle]="ButtonStyles.OUTLINE_PRIMARY"
              [buttonSize]="ButtonSizes.XSMALL"
              (click)="navigateToReference(ref)"
            ></ziro-button>
          </div>
        }
      }
    </ziro-collapsible-section-card>
  </div>
  <div class="call-flow-container__content">
    @for (flow of allCallFlows(); track flow.id) {
      <div [hidden]="selectedCallFlow()?.id !== flow.id">
        <ziro-auto-attendants-call-flow-edit
          [callFlow]="flow"
          [tenantId]="tenantId()"
          [allHolidays]="allHolidays()"
          (callFlowNameChange)="onHolidayCallFlowNameChange(flow.id, $event)"
          (greetingUpdate)="onGreetingUpdate(flow.id, $event)"
          (navigateToBusinessHours)="onNavigateToBusinessHours()"
          (validityChange)="onFlowValidityChange($event.flowId, $event.isValid)"
        ></ziro-auto-attendants-call-flow-edit>
      </div>
    }
  </div>
</div>
